import React from "react";
import {ZIndex} from "../../types/z-index";
import {IServiceFactory} from "../../services/service-factory.interface";

export function getCommonModalContentStyles(): React.CSSProperties {
    return {
        padding: 0,
        overflowX: "hidden",
        zIndex: ZIndex.Modal
    }
}

export function getCommonModalOverlayStyles(services: IServiceFactory): React.CSSProperties {
    return {
        backgroundColor: `rgba(${services.theme.currentTheme.colors.mediumRgb}, 0.8)`,
        zIndex: ZIndex.Modal - 2
    }
}